import { render, staticRenderFns } from "./CheckoutLoader.vue?vue&type=template&id=ddfbf7a8&"
import script from "./CheckoutLoader.vue?vue&type=script&lang=js&"
export * from "./CheckoutLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports